import React, { useEffect } from 'react'

import { Spinner } from '@wartek-id/spinner'

import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

export function PageGuardGuru({ children }: { children: React.ReactNode }) {
  const { isGuru, isSuccess, leave } = useRoleContext()

  useEffect(() => {
    if (isSuccess && !isGuru) {
      leave()
    }
  }, [isSuccess, isGuru, leave])

  if (!isSuccess || !isGuru)
    return (
      <div className="flex p-10">
        <div className="m-auto">
          <Spinner data-testid="loading-spinner-content" />
        </div>
      </div>
    )

  return <>{children}</>
}
